import type { AxiosResponse } from 'axios';

import client from 'api/client';
import type { RecommendedFieldsOfStudyResponse } from 'types';

export const getRecommendedFieldsOfStudy = (
    country: string,
    description: string
): Promise<AxiosResponse<RecommendedFieldsOfStudyResponse>> => {
    return client.get('/recommended_fields_of_study', { params: { country, description } });
};
